<template lang="pug">
section
  s-page-title(:previous='true' title='Отчет по принятым квартирам')
  v-card
    v-alert(
      :value="true"
      color="success"
      icon="warning"
      outline
    ) В отчете отображаются все категории чеклиста с ответами (или без) пользователя! 
  v-card
    v-card-text
      div(class='bolder') {{ session.complex_name + ', ' +session.object_name + ', кв(пом) №' + session.room }}
      div() {{ session.user_name + ', 8 ' + session.phone }}
  v-tabs(color='dark' slider-color='primary')
      v-tab Чеклист
      v-tab-item(:transition='false' :reverse-transition='false')
        v-card
          v-data-table(
              :loading='isLoading'
              :headers='headers'
              :items='report.checkList'
              hide-actions
              dense
            )
              template(slot='items' slot-scope='props')
                tr()
                  td() {{ props.item.id }}
                  td() {{ props.item.name }}
                  td()
                  td()
                    div(v-for="comment in props.item.comments") {{comment}}
                tr(v-for="(subItem) in props.item.sub_categories" :key="subItem.id" :class='{ "no-data": !subItem.done }')
                  td() {{ subItem.id }}
                  td()
                    div(class='sub-item') {{ subItem.name }}
                  td()
                    div(v-if='subItem.input_type=="check"')
                      v-icon(v-if='subItem.checked==true' small color='green') check_box
                      v-icon(v-if='subItem.checked==false' small color='green') check_box_outline_blank
                  td()
                    div(v-for="comment in subItem.comments") {{comment}}
    
</template>

<script>
import http from '@/http'

export default {
  props: ['sessionId'],
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '4%',
        sortable: false
      },
      {
        text: 'Категория',
        align: 'left',
        value: 'fio',
        width: '33%',
        sortable: false
      },
      {
        text: 'Принято',
        align: 'left',
        value: 'fio',
        width: '10%',
        sortable: false
      },
      {
        text: 'Комментарий',
        align: 'left',
        value: 'position',
        width: '33%',
        sortable: false
      }
    ],
    isLoading: false,
    report: {},
    session: {}
  }),

  created() {
    this.fetch()
  },
  methods: {
    async fetch() {
      this.isLoading = true
      try {
        this.report = (
          await http.get('/checklist/report/' + this.sessionId)
        ).data
      } catch (e) {
        this.$root.showSnack('Не удалось загрузить отчет')
      }
      this.session = this.report.session
      this.isLoading = false
    },
    refreshReport() {
      this.fetch()
    },
    changeComplex(complex = {}) {
      this.complex = complex
      this.object = null
      this.fetch()
    },
    changeObject(object = null) {
      this.object = object
      this.fetch()
    }
  },

  computed: {}
}
</script>

<style scoped>
.sub-item {
  margin-left: 20px;
}
.bolder {
  font-weight: 500;
  font-size: 15px;
}
.in_progress .bolder {
  color: red;
}

.finished .bolder {
  color: green;
}
.no-data {
  color: #cccccc;
}
</style>
